import {Component, computed, inject, ChangeDetectionStrategy} from '@angular/core';
import {config} from "../../../../config";
import {ProgressBarComponent, screenSize} from "@mindpath/shared";
import {AppendAppStateParamsPipe} from "../../../pipes/append-app-state-params.pipe";
import {ExtendedModule, FlexModule} from "@ngbracket/ngx-layout";
import {NavService} from "../../../services/nav.service";
import {ReferralSourceService} from "../../../services/referral-source.service";

@Component({
  selector: 'app-header',
  imports: [
    AppendAppStateParamsPipe,
    FlexModule,
    ProgressBarComponent,
    ExtendedModule
  ],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  protected readonly config = config;
  protected readonly screenSize = screenSize;
  protected readonly navSvc = inject(NavService);
  readonly #referral = inject(ReferralSourceService);

  /** A referral visit from the main site returns to the page it came from. Null means the default. */
  protected readonly logoHref = computed(() => this.#referral.returnUrl() ?? config.endpoints.mainSite);
  protected readonly referralLogoSrc = computed(() => {
    const referralId = this.#referral.referralSourceId();
    if (!referralId) {
      return null;
    }
    return `${config.endpoints.mainSite}/wp-content/uploads/referrals/${referralId}.png`
  });
}
